import { useEffect, useRef, useState } from 'react'

/**
 * Garde un onglet EN VIE quand on le quitte (S28, ecarts E-10/E-11).
 *
 * Avant : `{hubTab === 'account' && <HubAccount />}`. Quitter l'onglet
 * DEMONTAIT la page ; y revenir la remontait a neuf — etat perdu, `useEffect`
 * rejoues, requetes refaites, squelette de chargement, animation d'entree
 * relancee. C'est ce qui donnait la sensation « ca recharge » et « ca s'affiche
 * en deux temps » (le squelette apparait, puis le contenu apparait).
 *
 * Apres : la page est montee au PREMIER affichage, puis simplement masquee en
 * CSS quand on la quitte. Elle garde son etat et ses donnees ; y revenir est
 * instantane, sans requete ni animation rejouee — le comportement du prototype,
 * qui garde tout en memoire.
 *
 * Trois precautions :
 *  - montage PARESSEUX : un onglet jamais ouvert ne coute rien (on ne charge
 *    pas les donnees de tous les onglets au demarrage) ;
 *  - `hidden` + `display:none` : le contenu masque sort du flux ET de l'arbre
 *    d'accessibilite — pas de lecture par un lecteur d'ecran, pas de tabulation
 *    vers des boutons invisibles ;
 *  - `display:none` REINITIALISE les animations CSS : elles repartiraient a
 *    chaque retour. On neutralise donc les animations d'ENTREE (classe
 *    `.sans-anim-entree`, cf. index.css) une fois l'onglet quitte — pas avant,
 *    sinon on couperait l'animation en cours pendant la premiere visite.
 *    Les animations d'ambiance (halos, RINA, pulse) ne sont pas touchees.
 *
 * ⚠️ Ne pas y mettre de modale : les modales du portail passent par
 * `createPortal(document.body)` et echapperaient au masquage — elles
 * resteraient visibles apres un changement d'onglet. Les laisser en dehors.
 */
function TabPane({ actif, children }) {
  const [monte, setMonte] = useState(actif)
  // true des que l'onglet a ete quitte une fois : l'entree a deja ete jouee.
  const [dejaQuitte, setDejaQuitte] = useState(false)
  const etaitActif = useRef(actif)

  useEffect(() => {
    if (actif) setMonte(true)
    // Transition actif -> inactif : la premiere visite est terminee.
    if (etaitActif.current && !actif) setDejaQuitte(true)
    etaitActif.current = actif
  }, [actif])

  if (!monte && !actif) return null

  return (
    <div
      hidden={!actif}
      className={dejaQuitte ? 'sans-anim-entree' : undefined}
      style={actif ? undefined : { display: 'none' }}
    >
      {children}
    </div>
  )
}

export default TabPane
